<script setup>
import {computed, ref} from 'vue'

const props = defineProps({
    subscription: {
        type: Object,
        required: true,
    },
})

const isCollapsed = ref(true)

const payments = computed(() => props.subscription?.payments ?? [])

const toggleVisibility = () => {
    isCollapsed.value = !isCollapsed.value
}
</script>

<template>
    <div>
        <button
            v-if="payments.length > 1 && isCollapsed"
            type="button"
            class="mf-link-immune mf-link text-sm"
            @click="toggleVisibility"
        >
            {{ _mft('invoiceLink:nPayments', {count: payments.length}) }}
        </button>

        <ul v-if="!isCollapsed || payments.length === 1">
            <li
                v-for="p in payments"
                :key="p.id"
                class="grid grid-cols-2 gap-2 py-1"
                :data-payment-id="p.id"
            >
                <div class="text-sm">
                    <div class="flex items-center space-x-2">
                        <a
                            :href="route('invoice-link.purchase.payment.receipt.show', [subscription.uuid, p.id])+'?media=screen'"
                            target="_blank"
                        >
                            <span class="mf-link-immune mf-link">{{ p.issued_at_user_tz }}</span>
                            <i class="fa-regular fa-arrow-up-right-from-square text-xxs ml-1 text-gray-500"></i>
                        </a>
                        <span
                            v-if="subscription.payment_method === 'invoice'"
                            class="text-xs"
                        >
                            {{ _mft('invoiceLink:purchase.state.'+p.state) || p.state }}
                        </span>
                        <span
                            v-else
                            class="bg-white border rounded-md px-1 py-px text-gray-500 text-xs"
                        >
                            {{ _mft('invoiceLink:purchase.state.'+p.state) || p.state }}
                        </span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
